export default  {
    component: 'weather_station',
    name: 'weather_station',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'WS ID',
            param: 'ws_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, ws id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `Concatination for each device id's [1-1]`
          },
          {
            name: 'WS Name',
            param: 'ws_name',
            type: 'text',
            description: `> For each block, ws name should be unique`
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of Block Name-Room Name-Device Name`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for all the parameters available:
            - **irradiance** - [irradiance vertical,horizontal]
            - **temperature** - [ambient, module]
            - **wind** -  [speed]
            - **rain** - [rain_gauge]
            - **pressure** - [pressure]
            - **direction** - [direction]
            - **humidity** - [humidity]`
          },
          {
            name: 'Temperature (Ref. block Id)',
            param: 'temp_ref_block_id',
            type: 'number',
            description: `In order to plot **"irradiance(PoA)"** graph in inverter dashboard we need to refer to which block id, the ws id PoA data exist.`
          },
          {
            name: 'Irradiance (Ref. device Id)',
            param: 'irr_ref_device_id',
            type: 'number',
            description: `In order to plot **"irradiance(PoA)"** graph in inverter dashboard we need to refer to which ws id PoA data exist.`
          },
          {
            name: 'Reading frequency',
            param: 'reading_frequency',
            type: 'number',
            description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
          },
          {
            name: 'Missing Ppacket Count',
            param: 'missing_packet_count',
            type: 'number',
          },
          {
            name: 'Latitude',
            param: 'latitude',
            type: 'number',
          },
          {
            name: 'Longitude',
            param: 'longitude',
            type: 'number',
          },
          {
            name: 'Radiation Count',
            param: 'radiation_count',
            type: 'number',
            description: `Add radiation count`
          },
          {
            name: 'Module Temp Count',
            param: 'module_temp_count',
            type: 'number',
            description: `Add module count`
          },
          {
            name: 'Table Parameters',
            param: 'table_parameters',
            type: 'json',
            description: `Any paramter or name changed is added in JSON format:
            - (if only 1 module) {"module_temp": [{"name": "Module Temp", "unit": "(°C)"}], "ambient_temp": {"name": "Ambient Temp", "unit": "(°C)"}, "irradiance_vertical": {"name": "PoA", "unit": "(w/m²)"}, "irradiance_horizontal": {"name": "GHI", "unit": "(w/m²)"}}
            - (if more than 1 module or radiation) {"radiation": [{"name": "Albedometer_Direct", "unit": "(w/m²)"}, {"name": "Albedometer_Reflected", "unit": "(w/m²)"}, {"name": "POA-1-T12(Jollymood Bifacial)", "unit": "(w/m²)"}, {"name": "POA-2-T6(Trina)", "unit": "(w/m²)"}], "wind_speed": {"name": "Wind Speed", "unit": "(m/s)"}, "module_temp": [{"name": "T2-GCL-Bifacial", "unit": "(°C)"}, {"name": "T12-Jollymood-Bifacial", "unit": "(°C)"}, {"name": "T7-Longi-Bifacial", "unit": "°C"}, {"name": "T6-Trina(White glass)", "unit": "(°C)"}, {"name": "T14-GCL-Bifacial", "unit": "(°C)"}], "ambient_temp": {"name": "Ambient Temp", "unit": "(°C)"}, "irradiance_vertical": {"name": "PoA", "unit": "(w/m²)"}, "irradiance_horizontal": {"name": "GHI", "unit": "(w/m²)"}}`},          
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'json',
            description: `Any paramter or name changed is added in JSON format:
            - (if only 1 module) {"module_temp": {"name": "Module Temp", "unit": "(°C)"}, "ambient_temp": {"name": "Ambient Temp", "unit": "(°C)"}, "irradiance_vertical": {"name": "PoA", "unit": "(w/m²)"}, "irradiance_horizontal": {"name": "GHI", "unit": "(w/m²)"}}
            - (if more than 1 module or radiation) {"radiation": [{"name": "Albedometer_Direct", "unit": "(w/m²)"}, {"name": "Albedometer_Reflected", "unit": "(w/m²)"}, {"name": "POA-1-T12(Jolly mood Bifacial)", "unit": "(w/m²)"}, {"name": "POA-2-T6(Trina)", "unit": "(w/m²)"}], "module_temp": [{"name": "T2-GCL-Bifacial", "unit": "(°C)"}, {"name": "T12-Jollymood-Bifacial", "unit": "(°C)"}, {"name": "T7-Longi-Bifacial", "unit": "°C"}, {"name": "T6-Trina(White glass)", "unit": "(°C)"}, {"name": "T14-GCL-Bifacial", "unit": "(°C)"}]}`

          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
            description: `- If only 1 ws -> {"module_temp": {"nameMap": ["Module Temp"], "multiple": false}}
            - More than 1 ws -> {"module_temp": {"nameMap": ["Module Temp-1", "Module Temp-2"], "multiple": true}}`
          },
          {
            name: 'Filter Config',
            param: 'filter_config',
            type: 'json',
            description: `Add threshold value for junk values e.g {"validationRules": {"irradiance_vertical": {"maxValue": 1500, "minValue": 0}, "irradiance_horizontal": {"maxValue": 1500, "minValue": 0}}}`
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `In order to remove unwanted parameters from analytics. *\(e.g rm-wind_speed)`
          },
          {
            name: 'Model',
            param: 'model',
            type: 'text',
          }
    ]
  }




